export default {"src":"/_next/static/media/eighteen-plus.34f042ba.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};